import { useEffect } from 'react';

const GlobalScrollListener = ({ loadMore }) => {
    useEffect(() => {
        const scrollableElement = document.querySelector('.layout__content');

        const handleScroll = () => {
            if (
                (1 + scrollableElement.scrollTop + scrollableElement.clientHeight) >=
                scrollableElement.scrollHeight
            ) {
                loadMore();
            }
        };

        scrollableElement.addEventListener('scroll', handleScroll);
        return () => {
            scrollableElement.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return null;
}

GlobalScrollListener.propTypes = {
};

export default GlobalScrollListener;